<template>
  <div class="cursor-pointer" @click="showBody = !showBody">
    <div class="flex items-center gap-2">
      <div class="flex-shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          class="w-6 h-6 text-gray-400"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
          />
        </svg>
      </div>
      <div class="text-sm">
        <div class="font-medium text-gray-900">Emailed candidate: {{ email.subject || 'No subject' }}</div>
      </div>
    </div>
    <div>
      <div v-if="showBody" class="mt-1 text-sm text-gray-700 user-generated-content">
        <div v-html="sanitize(email.body)"></div>
      </div>
      <div class="mt-2 space-x-2 text-sm flex">
        <span class="font-medium text-gray-500">{{ fromNow(email.created_at) }} ago | {{ email.user.email }}</span>
        <span
          v-if="email.postmark_delivered_at"
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
          >Delivered</span
        >
        <span
          v-if="email.postmark_bounced_at"
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
          >Bounced</span
        >
        <span
          v-if="email.postmark_received_at"
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
          >Opened</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeRichText } from '../../utilities/sanitization';
import DateUtility from '../../utilities/dates';

export default {
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBody: false,
    };
  },
  methods: {
    ...DateUtility,
    sanitize(html) {
      return sanitizeRichText(html);
    },
  },
};
</script>
